const GA_MEASUREMENT_ID = 'G-0533QWMLC9';

let initialized = false;

function loadGtagScript() {
  return new Promise((resolve) => {
    try {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.head.appendChild(script);
    } catch (e) {
      resolve(false);
    }
  });
}

function initDataLayer() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
  });
}

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  const boot = () => {
    loadGtagScript().then((ok) => {
      if (ok) initDataLayer();
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(boot);
  } else {
    setTimeout(boot, 2000);
  }
}

export function trackPageView(path) {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', {
    page_title: path,
    page_location: window.location.origin + path,
  });
}
